<button kendoPopoverAnchor [popover]="popup" showOn="hover" #anchor kendoButton (click)="this.toggleHelp()" size="small" [themeColor]="'tertiary'" [svgIcon]="this.icons.infoSolid"></button>
<kendo-popover title="Help" width="300px" #popup>
    <ng-template kendoPopoverBodyTemplate>
        <div>{{this.description()}}</div>
    </ng-template>
</kendo-popover>